export default {
  segment_tabs: {
    placeholder: 'ค้นหา',
  },

  native_custom_selector: {
    placeholder: 'ค้นหา',
    no_data: 'ไม่มีข้อมูล',
  },

  modal: {
    close: 'ปิด',
    confirm: 'ตกลง',
    cancel: 'ยกเลิก',

    report: {
      warning: {
        title: 'ยืนยัน',
        desc: 'ต้องการดาวน์โหลด Report ล่าสุดหรือไม่',
      },
    },
  },

  button: {
    search: {
      placeholder: 'ค้นหา',
    },
  },

  pagination: {
    of: 'จาก',
    list: 'รายการ',
    page: ' ',
    go_to: 'ไปยังหน้า',
  },

  filter_table: {
    title: 'ตัวกรอง',
    topic_sorting: 'เรียงตาม:',
    topic_filter: 'กรองตาม',
    column: 'คอลัมน์:',
    all_item: 'ทั้งหมด:',
    topic_preview: 'ตัวกรองทั้งหมด (ตัวอย่าง)',
    button_apply: 'นำไปใช้',
    button_clear: 'ล้าง',
    components: {
      select_operator: {
        empty: 'ไม่พบข้อมูล',
      },
      select_column: {
        empty: 'ไม่พบข้อมูล',
      },
      ordering: {
        asc: 'จากน้อยไปมาก',
        desc: 'จากมากไปน้อย',
      },
      preview_filter: {
        no_filter: 'ไม่มีตัวกรอง',
      },
    },
  },
};
